<template>
  <div>
    <div class="flex">
      <button @click="goPrev">Previous</button>
      <button @click="goNext">Next</button>
    </div>
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide><booking-dashboard></booking-dashboard></swiper-slide>
      <swiper-slide><homespace></homespace></swiper-slide>
      <swiper-slide>Slide 4</swiper-slide>
      <swiper-slide>Slide 5</swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import BookingDashboard from "../../pages/BookingPages/BookingDashboard.vue";
import Homespace from "../Homespace/Homespace.vue";

export default {
  name: "MyComponent",
  components: { Swiper, SwiperSlide, BookingDashboard, Homespace },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
        },
        simulateTouch: false,
        preventClicks: false,
        // Some Swiper option/callback...
      },
    };
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    handleKeydown(event) {
      if (event.code === "ArrowLeft") {
        this.goPrev();
      } else if (event.code === "ArrowRight") {
        this.goNext();
      }
    },
    goPrev() {
      this.$refs.mySwiper.$swiper.slidePrev();
    },
    goNext() {
      this.$refs.mySwiper.$swiper.slideNext();
    },
  },
};
</script>

<style scoped>
.page-container {
  /* Add styling as per your needs */
  width: 100%;
  height: 80vh;
  overflow: hidden;
}
::v-deep .swiper-wrapper {
  height: 100vh;
}
</style>
